import React from 'react';
import PropTypes from 'prop-types';
import { FIXED_TOP } from 'utils/sectionTypes';
import { section } from '../decorators';

const propTypes = {
  type: PropTypes.string,
};

const defaultProps = {};

const Placeholder = ({ type }) => (
  <div>The section {type} is no longer available.</div>
);

Placeholder.propTypes = propTypes;
Placeholder.defaultProps = defaultProps;

export default section(
  { name: 'Placeholder', region: FIXED_TOP, deprecated: true },
  { menu: { items: ['delete'] }, subsections: [], widgets: [], resolve: null },
)(Placeholder);
